import React, { FC, useState, useRef } from "react";
import { useRouter } from "next/router";
import { YotpoProductReview } from "@Components/yotpo-product-review/YotpoProductReview";
import { getFullPath } from "@Utils/url";
import { useLocaleRouter } from "@wff/hooks/useLocaleRouter";
import { ProductDetails, ProductDisclaimer } from ".";
import classes from "./ProductDetailContainer.module.scss";

const DISCLAIMER_CONTENT_LENGTH = 66;
const DISCLAIMER_READ_MORE = " Read More";
const DISCLAIMER_SHOW_LESS = " Show Less";

interface Props {
  productData: any;
}

const useProductData = (productData: any) => {
  const { asPath } = useRouter();
  const url = getFullPath(asPath);
  const { languageCode } = useLocaleRouter();
  const { productId = "", imageSet = {} } =
    productData.pageContent?.productData || {};
  const currentProduct = productData?.ctData?.masterData?.current;
  const title = currentProduct?.name ? currentProduct?.name[languageCode] : "";
  const disclaimerText = productData?.pageContent?.disclaimer;

  return {
    productId,
    title,
    url,
    imageUrl: `${imageSet?.mainImage?.url}?fm=webp&w=1920&h=1080` || "",
    disclaimerText,
  };
};

export const ProductDetailContainer: FC<Props> = ({ productData }) => {
  const { productId, title, url, imageUrl, disclaimerText } =
    useProductData(productData);
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const getDisclaimerText = (text: any) => {
    const disclaimerHeading = text?.json?.content[0].content[0].value;
    const disclaimerContent = text?.json?.content[0].content[1].value;
    return (
      <div className={classes["disclaimerContainer"]}>
        <span className={classes["disclaimerHeading"]}>
          {disclaimerHeading}
        </span>
        <span>
          {isReadMore
            ? disclaimerContent.slice(0, DISCLAIMER_CONTENT_LENGTH)
            : disclaimerContent}
          {disclaimerContent.length > DISCLAIMER_CONTENT_LENGTH && (
            <span>
              <span>{isReadMore ? "..." : ""}</span>
              <span
                className={classes["disclaimerReadMore"]}
                onClick={toggleReadMore}
              >
                {isReadMore ? DISCLAIMER_READ_MORE : DISCLAIMER_SHOW_LESS}
              </span>
            </span>
          )}
        </span>
      </div>
    );
  };

  const reviewsRef = useRef<null | HTMLDivElement>(null);

  return (
    <div className={classes["product-detail-container"]}>
      <ProductDetails productData={productData} reviewsRef={reviewsRef} />

      <div ref={reviewsRef}>
        <YotpoProductReview
          id={productId}
          price={"TODO"}
          currency={"USD"}
          name={title}
          url={url}
          imageUrl={imageUrl}
        />
      </div>

      <div className={classes["product-disclaimer-mobile"]}>
        {getDisclaimerText(disclaimerText)}
      </div>
      <div className={classes["product-disclaimer-desktop"]}>
        <ProductDisclaimer disclaimerText={disclaimerText} />
      </div>
    </div>
  );
};
